
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface CitySelectProps {
  value: string;
  onChange?: (value: string) => void;
  onValueChange?: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  country?: string;
}

const CitySelect = ({ 
  value, 
  onChange,
  onValueChange,
  label, 
  placeholder = "Zgjidhni qytetin", 
  required = false,
  country = "albania"
}: CitySelectProps) => {
  // Cities in Albania
  const albanianCities = [
    'Tiranë', 'Durrës', 'Vlorë', 'Shkodër', 'Elbasan', 
    'Fier', 'Korçë', 'Berat', 'Lushnjë', 'Kavajë', 
    'Lezhë', 'Gjirokastër', 'Sarandë', 'Pogradec', 'Kukës',
    'Peshkopi', 'Krujë', 'Laç', 'Përmet', 'Tepelenë',
    'Gramsh', 'Librazhd', 'Bulqizë', 'Ersekë', 'Burrel'
  ];

  // Cities in Kosovo
  const kosovoCities = [
    'Prishtinë', 'Prizren', 'Ferizaj', 'Pejë', 'Gjakovë',
    'Gjilan', 'Mitrovicë', 'Podujevë', 'Vushtrri', 'Suharekë',
    'Rahovec', 'Drenas', 'Lipjan', 'Malishevë', 'Kamenicë',
    'Viti', 'Deçan', 'Istog', 'Klinë', 'Skenderaj',
    'Dragash', 'Fushë Kosovë', 'Kaçanik', 'Shtime', 'Obiliq'
  ];

  // Choose which city list to display based on country
  const cities = country.toLowerCase() === "kosovo" ? kosovoCities : albanianCities;

  // Handle value change
  const handleChange = (value: string) => {
    if (onChange) onChange(value);
    if (onValueChange) onValueChange(value);
  };

  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <Select value={value} onValueChange={handleChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {cities.map((city) => (
            <SelectItem key={city} value={city}>
              {city}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CitySelect;
